import React from "react";
import filter from "../../assests/images/filter.svg";

export default function FilterMenuDocker({ handleFilterChange, filters }) {
  return (
    <div className="dropdown">
      <button
        className="btn form-label filter-box"
        type="button"
        id="filter"
        data-bs-toggle="dropdown"
        data-bs-auto-close="outside"
        aria-expanded="false"
      >
        <img src={filter} alt="" />
        <span style={{ paddingLeft: "8px" }}>Filter</span>
      </button>

      <ul
        className="dropdown-menu p-3"
        aria-labelledby="filter"
        id="AppDropDownId"
        style={{ minWidth: "13rem" }}
      >
        <li className="sub-step-link">Add Filters</li>
        <li>
          <div className="accordion" id="filterActivationStatus">
            <div className="border-0" style={{ padding: "16px 0 0px 0" }}>
              <button
                className="accordion-button collapsed no-focus-outline"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseFileType"
                aria-expanded="false"
                aria-controls="collapseFileType"
                style={{ padding: "0 0 10px 0" }}
              >
                <span className="review-text menu-options">Type</span>
              </button>

              <div
                id="collapseFileType"
                className="accordion-collapse collapse"
                data-bs-parent="#filterFileType"
              >
                <div className="pb-0 px-2">
                  <div className="form-check mb-1">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="runType"
                      id="iSort-Fractions"
                      value="iSort-frac"
                      onChange={() => { }}
                      checked={filters.module === "iSort-frac"}
                      onClick={(e) =>
                        handleFilterChange("module", e.target.value)
                      }
                    />
                    <label className="form-check-label sub-text">
                      iSort-Fractions
                    </label>
                  </div>

                  <div className="form-check mb-0 pb-0">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="runType"
                      id="iSort-Hires"
                      value="iSort-hires"
                      onChange={() => { }}
                      checked={filters.module === "iSort-hires"}
                      onClick={(e) =>
                        handleFilterChange("module", e.target.value)
                      }
                    />
                    <label className="form-check-label sub-text">
                      iSort-Hires
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>

        <li>
          <div className="accordion" id="filterCreatedDate">
            <div className="border-0" style={{ padding: "10px 0 0 0" }}>
              <button
                className="accordion-button collapsed no-focus-outline"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseUpload"
                aria-expanded="false"
                aria-controls="collapseUpload"
                style={{ padding: "0px 0 10px 0" }}
              >
                <span className="review-text menu-options">Timestamp</span>
              </button>

              <div
                id="collapseUpload"
                className="accordion-collapse collapse sub-text px-2"
                data-bs-parent="#filterUpload"
              >
                <div>
                  <label>Start Date</label>
                  <input
                    className="form-control"
                    type="date"
                    name="startDate"
                    max={new Date().toISOString().split("T")[0]}
                    value={filters.startDate || ""}
                    onChange={(e) =>
                      handleFilterChange("startDate", e.target.value)
                    }
                  />
                </div>
                <div>
                  <label>End Date</label>
                  <input
                    className="form-control"
                    type="date"
                    name="endDate"
                    min={filters.startDate || null}
                    max={new Date().toISOString().split("T")[0]}
                    value={filters.endDate || ""}
                    onChange={(e) =>
                      handleFilterChange("endDate", e.target.value)
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  );
}
